import { FC, ReactNode } from 'react';
import { Link } from '@hopskipdrive/react-components';

import Logo from '../../../../assets/hsd-logo.svg';

import {
  ArtworkStyled,
  ContentStyled,
  FooterStyled,
  HeaderStyled,
  LayoutStyled,
  MainStyled,
} from './LoginTemplateV2.styles';

interface LoginTemplateV2Props {
  children: ReactNode;
}

export const LoginTemplateV2: FC<LoginTemplateV2Props> = ({ children }) => (
  <LayoutStyled data-testid="redesigned-login-layout">
    <HeaderStyled>
      <img src={Logo} alt="HopSkipDrive" />
    </HeaderStyled>
    <MainStyled>
      <ContentStyled>
        {children}
        <FooterStyled>
          <p>Trouble Logging in? Contact</p>
          <Link href="mailto:help@hopskipdrive.com">help@hopskipdrive.com</Link>
        </FooterStyled>
      </ContentStyled>
      <ArtworkStyled aria-hidden="true" data-testid="redesigned-login-artwork" />
    </MainStyled>
  </LayoutStyled>
);
